import { render, staticRenderFns } from "./ProductInquiryReg.vue?vue&type=template&id=5410ca79&scoped=true"
import script from "./ProductInquiryReg.vue?vue&type=script&lang=js"
export * from "./ProductInquiryReg.vue?vue&type=script&lang=js"
import style0 from "./ProductInquiryReg.vue?vue&type=style&index=0&id=5410ca79&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410ca79",
  null
  
)

export default component.exports